import axios from 'axios'
import handleError from './handleError'

export const FETCH_CART_URL = '/cart/index';
export const ADD_ITEM_URL = '/cart/additem';
export const REMOVE_ITEM_URL = '/cart/removeitem';
export const UPDATE_DATA_URL = '/cart/updatedata';
export const ADD_PARTICIPANT_TO_ITEM_URL = '/cart/addparticipanttoitem';
export const UPDATE_PARTICIPANT_FOR_ITEM_URL = '/cart/updateparticipantforitem';
export const REMOVE_PARTICIPANT_FROM_ITEM_URL = '/cart/removeparticipantfromitem';
export const UPLOAD_FILE_TO_PARTICIPANT_URL = '/cart/uploadfiletoparticipant';
export const UPLOAD_FILE_TO_DATA_URL = '/cart/uploadfiletodata';
export const PROCESS_ORDER_URL = '/cart/processorder';

export const fetchCart = () => {
    return new Promise((resolve, reject) => {

        axios.get(FETCH_CART_URL)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const addItem = (identifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            identifier: identifier
        };

        axios.post(ADD_ITEM_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const removeItem = (identifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            identifier: identifier
        };

        axios.post(REMOVE_ITEM_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const updateData = (data) => {
    return new Promise((resolve, reject) => {
        const params = {
            data: data
        };

        axios.post(UPDATE_DATA_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const addParticipantToItem = (participant, identifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            participant: participant,
            identifier: identifier
        };

        axios.post(ADD_PARTICIPANT_TO_ITEM_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const updateParticipantForItem = (participant, itemIdentifier, identifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            participant: participant,
            itemIdentifier: itemIdentifier,
            identifier: identifier
        };

        axios.post(UPDATE_PARTICIPANT_FOR_ITEM_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const removeParticipantFromItem = (itemIdentifier, identifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            itemIdentifier: itemIdentifier,
            identifier: identifier
        };

        axios.post(REMOVE_PARTICIPANT_FROM_ITEM_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const uploadFileToParticipant = (file, fileName, fieldName, itemIdentifier, participantIdentifier) => {
    return new Promise((resolve, reject) => {
        const params = {
            file: file,
            fileName: fileName,
            fieldName: fieldName,
            itemIdentifier: itemIdentifier,
            participantIdentifier: participantIdentifier
        };

        axios.post(UPLOAD_FILE_TO_PARTICIPANT_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const uploadFileToData = (file, fileName) => {
    return new Promise((resolve, reject) => {
        const params = {
            file: file,
            fileName: fileName
        };

        axios.post(UPLOAD_FILE_TO_DATA_URL, params)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};

export const processOrder = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(PROCESS_ORDER_URL)
            .then(response => { resolve(response.data) })
            .catch(error => { reject(handleError(error)) });
    });
};
